import React from "react";

/**
 * Reusable input component with consistent styling.
 * Additional props are forwarded to the underlying input element.
 */
export default function InputField({
  type = "text",
  value,
  onChange,
  placeholder = "",
  className = "",
  ...props
}) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`w-full h-9 rounded-lg border bg-white px-3 control-text outline-none focus:ring-2 focus:ring-primary ${className}`}
      {...props}
    />
  );
}
